import { render, staticRenderFns } from "./freightLook.vue?vue&type=template&id=bdd585b4&scoped=true&"
import script from "./freightLook.vue?vue&type=script&lang=ts&"
export * from "./freightLook.vue?vue&type=script&lang=ts&"
import style0 from "./freightLook.vue?vue&type=style&index=0&id=bdd585b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd585b4",
  null
  
)

export default component.exports